import styled, { css, keyframes } from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

const slide = keyframes`
  from {
    transform: translate3d(-100%, 0, 0);
  }
  to {
    transform: translate3d(250%, 0, 0);
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export const LoaderPage = styled.div`
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  background-color: rgba(20, 28, 50, 0.65);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  &.show {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const LoaderBox = styled.div`
  width: min(440px, 92vw);
  background: #ffffff;
  padding: 28px 24px;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(20, 28, 50, 0.3);
  text-align: center;
`;

export const LoaderSpinner = styled.div`
  width: 44px;
  height: 44px;
  margin: 0 auto 14px;
  border: 3px solid #dbe3f5;
  border-top-color: #0080ff;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoaderTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #242f57;
  margin-bottom: 8px;
  line-height: 1.35;
`;

export const LoaderPercent = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #0080ff;
  line-height: 1;
  margin-bottom: 12px;
`;

export const LoaderTrack = styled.div`
  height: 12px;
  border-radius: 6px;
  background: #e0e4ef;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const LoaderFill = styled.div`
  height: 100%;
  border-radius: 6px;
  background-image: linear-gradient(to right, #0099cc, #00cc88);
  transition: width 0.3s ease;
  width: ${(props) => (props.$indeterminate ? "40%" : "0%")};
  ${(props) =>
    props.$indeterminate
      ? css`
          animation: ${slide} 1.4s linear infinite;
        `
      : ""}
`;

export const LoaderHint = styled.div`
  font-size: 12px;
  color: #636e95;
  line-height: 1.4;
`;

export const LoaderStats = styled.div`
  width: 100%;
  margin: 4px 0 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f4f7fc;
  text-align: left;
`;

export const LoaderStatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #636e95;
  line-height: 1.6;

  strong {
    color: #242f57;
    font-weight: 700;
  }
`;

/* Kept for any legacy imports that still reference Spinner / LoaderContent */
export const Spinner = LoaderSpinner;
export const LoaderContent = styled.div`
  display: block;
  text-align: center;
`;

export const tableLoaderStyles = makeStyles({
  tableLoader: {
    height: 300,
    marginTop: 100,
    marginLeft: 100,
  },
  row: {
    display: "flex",
  },
  cell: {
    height: 30,
    width: 100,
    margin: 5,
  },
});
